import { useCallback, useState } from "react";
import { toast } from "sonner";
import { api, errMsg } from "../../lib/api";
import { useAuth } from "../../context/AuthContext";
import { useCommunity, captionFor, tgShareUrl, sourceOf } from "../../lib/community";
import { ShareCard } from "./ShareCard";
import { Scrim, CloseX, Confetti } from "./Overlay";
import { TgGlyph } from "./TgBits";

function Toggles({ win, amt, setAmt, name, setName }) {
  return (
    <div className="gw-tgl">
      {win && <label><input type="checkbox" checked={amt} onChange={(e) => setAmt(e.target.checked)} data-testid="share-toggle-amount" /> Show ₹ amount</label>}
      <label><input type="checkbox" checked={name} onChange={(e) => setName(e.target.checked)} data-testid="share-toggle-name" /> Show my name</label>
    </div>
  );
}

function SheetBody({ sheet, close }) {
  const { user } = useAuth();
  const card = sheet.card;
  const win = card.kind === "win";
  const [amt, setAmtRaw] = useState(false);
  const [name, setName] = useState(false);
  const [cap, setCap] = useState(() => captionFor(card, false));
  const [edited, setEdited] = useState(false);
  const [busy, setBusy] = useState("");
  const setAmt = (v) => { setAmtRaw(v); if (!edited) setCap(captionFor(card, v)); };
  const body = () => ({ ...sourceOf(sheet), show_amount: win && amt, show_name: name, caption: cap });

  const share = async () => {
    const w = window.open("", "_blank");
    setBusy("share");
    try {
      const { data } = await api.post("/community/share", body());
      const url = tgShareUrl(`${window.location.origin}${data.path}`, cap);
      if (w) w.location.href = url; else window.location.href = url;
      useCommunity.getState().load();
      toast.success("Telegram opened — choose the chat to post in");
      close();
    } catch (e) { if (w) w.close(); toast.error(errMsg(e)); }
    setBusy("");
  };
  const copy = async () => {
    try { await navigator.clipboard.writeText(cap); toast.success("Caption copied"); } catch (e) { toast.error("Could not copy — select the text and copy it"); }
  };
  const download = async () => {
    setBusy("img");
    try {
      const { data } = await api.post("/community/card.png", body(), { responseType: "blob" });
      const a = document.createElement("a");
      a.href = URL.createObjectURL(data);
      a.download = `greenwick-${card.symbol.replace(/\s+/g, "-")}.png`;
      a.click();
      setTimeout(() => URL.revokeObjectURL(a.href), 2000);
    } catch (e) { toast.error("Could not create the image"); }
    setBusy("");
  };
  return (
    <div className="gw-ring" data-testid="share-sheet">
      <div className="inn" style={{ padding: 20 }}>
        <div className="flex items-start gap-2.5">
          <div>
            <div className="gw-eb">{win ? "Share your win" : "Share this trade"}</div>
            <h3 className="gw-d text-[24px] mt-1.5 leading-none">{win ? <>Show <span className="gw-it">the community.</span></> : <>Post it to the <span className="gw-it">community.</span></>}</h3>
          </div>
          <CloseX onClick={close} testid="share-sheet-close" />
        </div>
        <div className="mt-3.5"><ShareCard card={card} showAmount={win && amt} name={name ? user?.name : ""} /></div>
        <Toggles win={win} amt={amt} setAmt={setAmt} name={name} setName={setName} />
        <textarea className="gw-ta" aria-label="Caption" value={cap} maxLength={600} onChange={(e) => { setCap(e.target.value); setEdited(true); }} data-testid="share-caption-input" />
        <div className="gw-actions">
          <button type="button" className="gw-btn" onClick={share} disabled={!!busy} data-testid="share-to-community-button"><TgGlyph />Share to Community</button>
          <button type="button" className="gw-btn gh" onClick={copy} data-testid="share-copy-text-button">Copy text</button>
          <button type="button" className="gw-btn gh" onClick={download} disabled={!!busy} data-testid="share-download-image-button">{busy === "img" ? "Preparing…" : "Download image"}</button>
        </div>
        <button type="button" className="gw-btn gh gw-full mt-2" onClick={close} data-testid="share-not-now-button">Not now</button>
        <p className="text-[11px] mt-2.5" style={{ color: "var(--gw-dim)" }}>Opens Telegram with your card link and caption. You choose the chat; nothing is posted without you.</p>
      </div>
    </div>
  );
}

export function ShareSheet() {
  const sheet = useCommunity((s) => s.sheet);
  const close = useCallback(() => useCommunity.getState().closeSheet(), []);
  if (!sheet) return null;
  return (
    <>
      {sheet.card.kind === "win" && sheet.confetti && <Confetti />}
      <Scrim onClose={close} testid="share-sheet-overlay"><SheetBody key={sheet.card.trade_id} sheet={sheet} close={close} /></Scrim>
    </>
  );
}
